
export const Descendants = () => {
  return (
    <div id='category'>
      <div className="row">
        <div className="col-xs-12 col-md-6">
          <div className="about-text">
            <h2>THE DESCENDANTS</h2>
            <h4>T.G. Greybone founded The Greyhound Society along with other 6 founders and every greyhound belong to one of this 7 houses. Greybone, Ulrik, Crowell , Crestwood , McBarkler, Shelbylark and Voltarier.</h4>
            <h4>The 7 founders will not be available in the minting day instead they will be dropped for free to our Greyhound holders. If you have a Greyhound that belongs to the house of the founder being dropped, you will have chances to get it!.</h4>
          </div>
        </div>
        <div className="col-xs-12 col-md-6" style={{display: 'flex', justifyContent: 'center'}}>
          <img style={{width: 500}} src="./img/descendants.png" className="img-responsive" alt="" />{" "}
        </div>
      </div>
    </div>
  )
}
